<template>
  <a :id="myId" v-if="!isLastStep" class="btn btn-success btn-step" :href="nextRouteHref"><span>Continue </span><i class="fa fa-angle-right"></i></a>
</template>

<script>
  import routes from '../mixins/routes'

  export default {
    props: ['id'],
    mixins: [routes],
    computed: {
      myId () {
        return this.id || ''
      }
    }
  }
</script>
